import _ from 'lodash';
import React from 'react';

import LinkText from 'components/LinkText';
import StatusBox from 'components/StatusBox';
import Money from 'components/Money';

import {GOCARDLESS_PAYMENT_ACTION_STATUSES} from 'ducks/tenancy';
import {formatDate} from 'utils/datetime';

import './styles.css';

const LessSection = ({
  payments,
  creditNotes,
  openCreditNoteDetailModal,
  openPaymentDetailModal,
  openGocardlessPaymentDetailModal
}) => {
  if (_.isEmpty(payments) && _.isEmpty(creditNotes)) {
    return <div />;
  }
  const orderedPayments = _.orderBy(payments, 'paymentDate', 'asc');

  return (
    <div className="LessSection">
      {orderedPayments.map(payment => {
        return (
          <div key={payment.id}>
            {payment.gocardlessPayment && (
              <div className="section">
                <div className="header">
                  <LinkText
                    onClick={() =>
                      openGocardlessPaymentDetailModal(
                        payment.gocardlessPayment.id
                      )
                    }>
                    Less GC Payment →
                  </LinkText>
                  <div className="attempt">
                    <StatusBox
                      color={
                        GOCARDLESS_PAYMENT_ACTION_STATUSES[
                          payment.gocardlessPayment.lastStatus.value
                        ].color
                      }
                      status={
                        payment.gocardlessPayment.attempt ||
                        payment.gocardlessPayment.lastStatus.verbose
                      }
                    />
                  </div>
                  <div className="date">{formatDate(payment.paymentDate)}</div>
                </div>
                <div className="value">
                  <Money amount={payment.amountApplied} />
                </div>
              </div>
            )}
            {!payment.gocardlessPayment && (
              <div className="section">
                <div className="header">
                  <LinkText onClick={() => openPaymentDetailModal(payment.id)}>
                    Less Payment →
                  </LinkText>
                  {payment.voided && (
                    <div className="status">
                      <StatusBox color={StatusBox.RED} status="Void" />
                    </div>
                  )}
                  <div className="date">{formatDate(payment.paymentDate)}</div>
                </div>
                <div className="value">
                  <Money amount={payment.amountApplied} />
                </div>
              </div>
            )}
          </div>
        );
      })}
      {creditNotes.map(creditNote => {
        return (
          <div key={creditNote.id}>
            <div className="section">
              <div className="header">
                <LinkText
                  onClick={() => openCreditNoteDetailModal(creditNote.id)}>
                  Less Credit Note →
                </LinkText>
                {creditNote.voided && (
                  <div className="status">
                    <StatusBox color={StatusBox.RED} status="Void" />
                  </div>
                )}
                <div className="date">{formatDate(creditNote.dateIssued)}</div>
              </div>
              <div className="value">
                <Money amount={creditNote.totalIncludingTax} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LessSection;
